import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 20,
		rx: 4,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.17229 5.17229C5.40201 4.94257 5.77446 4.94257 6.00418 5.17229L10 9.16811L13.9958 5.17229C14.2255 4.94257 14.598 4.94257 14.8277 5.17229C15.0574 5.40201 15.0574 5.77446 14.8277 6.00418L10.8319 10L14.8277 13.9958C15.0574 14.2255 15.0574 14.598 14.8277 14.8277C14.598 15.0574 14.2255 15.0574 13.9958 14.8277L10 10.8319L6.00418 14.8277C5.77446 15.0574 5.40201 15.0574 5.17229 14.8277C4.94257 14.598 4.94257 14.2255 5.17229 13.9958L9.16811 10L5.17229 6.00418C4.94257 5.77446 4.94257 5.40201 5.17229 5.17229Z",
		fill: "white"
	})]
});
export default SvgIcDelete;
